import { render, staticRenderFns } from "./reviewTicketAffiliate.vue?vue&type=template&id=44e3e926&lang=pug"
import script from "./reviewTicketAffiliate.vue?vue&type=script&lang=js"
export * from "./reviewTicketAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports